import { useAgentContext } from '@Providers';

import { Skeleton } from '@Components/ui-v2/skeleton';

const ShimmerBar = ({ className = '', style }: { className?: string; style?: React.CSSProperties }) => (
  <Skeleton className={`bg-gray-200 ${className}`} style={style} />
);

const UserBubbleSkeleton = ({ width }: { width: string }) => (
  <div className="flex justify-end">
    <div
      className="rounded-xl border bg-white px-4 py-2.5"
      style={{
        width,
        borderColor: 'rgba(124, 108, 246, 0.12)',
        backgroundColor: 'rgba(124, 108, 246, 0.06)',
      }}>
      <Skeleton className="h-3 rounded bg-[#7c6cf6]/15" style={{ width: '75%' }} />
    </div>
  </div>
);

const AgentBlockSkeleton = ({ lines }: { lines: number[] }) => (
  <div className="space-y-2">
    {lines.map((width, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <ShimmerBar key={idx} className="h-3.5" style={{ width: `${width}%` }} />
    ))}
    <div className="flex gap-1 pt-1">
      <ShimmerBar className="h-6 w-6 rounded-md" />
      <ShimmerBar className="h-6 w-6 rounded-md" />
      <ShimmerBar className="h-6 w-6 rounded-md" />
    </div>
  </div>
);

const MessageListSkeleton = () => {
  const { mode } = useAgentContext();
  const isFullscreen = mode === 'fullscreen';
  const wrapperClass = isFullscreen ? 'mx-auto w-full min-w-0 max-w-3xl px-5 py-5 space-y-5' : 'min-w-0 p-6 space-y-6';

  return (
    <div className={wrapperClass}>
      <UserBubbleSkeleton width="55%" />
      <AgentBlockSkeleton lines={[80, 95, 60]} />
      <UserBubbleSkeleton width="42%" />
      <AgentBlockSkeleton lines={[90, 70]} />
    </div>
  );
};

export default MessageListSkeleton;
